import { getMacFromLocalStorage } from '../../api/auth';
import { getAtsKey, getBaseUrl, getSessionTicket } from '../../config';
import { ScriptService } from '../../controllers/ScriptService';

export class AtsSettings {
  public headers(version: string, overwrites?: Record<string, string>): HeadersInit {
    // NOTE: This `token` variable need to be here to asure the app to get the latest token from storage
    const token = localStorage.getItem('atsToken')
      ? { Authorization: `AtsToken ${localStorage.getItem('atsToken')}` }
      : undefined;

    return {
      'x-api-version': version,
      'ocp-apim-subscription-key': getAtsKey(),
      'x-device-type-id': 'app-web-general',
      ...token,
      ...overwrites,
    };
  }

  public titles(method: 'GET' | 'POST' = 'GET'): RequestInit {
    return {
      method,
      headers: this.headers('2.0'),
    };
  }

  public titlesSuggest(): RequestInit {
    return {
      headers: this.headers('2.0'),
    };
  }

  public layout(method: 'GET' | 'POST' = 'GET'): RequestInit {
    return {
      method,
      headers: this.headers('1.0'),
    };
  }

  public me(): RequestInit {
    return {
      headers: this.headers('1.0'),
    };
  }

  public playback(version: `${string}.${string}`): RequestInit {
    return {
      headers: this.headers(version, {
        'x-device-type-class': ScriptService._isSafari() ? 'apple' : 'web',
      }),
    };
  }

  public auth(method: 'GET' | 'POST' = 'GET', body?: RequestInit['body']): RequestInit {
    const sessionTicket = getSessionTicket();
    const ticket = sessionTicket.split(' ').join('');

    return {
      method,
      body,
      headers: this.headers('2.0', {
        Authorization: `Legacy ${ticket}`,
        'x-device-type-class': ScriptService._isSafari() ? 'apple' : 'web',
        'x-device-id': getMacFromLocalStorage(),
        'epg-url': getBaseUrl(),
        'content-type': 'application/json',
      }),
    };
  }
}

export const settings = new AtsSettings();
